import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// driver.css é importado em index.js (antes de index.css) para garantir a
// ordem correta no bundle -- ver comentário lá. Não reimportar aqui.
import { AuthProvider } from "./context/AuthContext";
import { WebSocketProvider } from "./context/WebSocketContext";
import ProtectedRoute, { AdminRoute, SuperAdminRoute } from "./components/shared/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";
import Integrations from "./pages/Integrations";
import Migration from "./pages/Migration";
import Team from "./pages/Team";
import Automations from "./pages/Automations";
import ResetPassword from "./pages/ResetPassword";
import Admin from "./pages/Admin";
import Tasks from "./pages/Tasks";
import { Toaster } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";

export default function App() {
  return (
    <AuthProvider>
      <WebSocketProvider>
        {/* delayDuration curto (200ms) -- ajuda contextual deve responder rápido ao
            passar o mouse, sem o delay padrão de 700ms do Radix */}
        <TooltipProvider delayDuration={200}>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Navigate to="/login" replace />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
              <Route path="/automations" element={<ProtectedRoute><Automations /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/integrations" element={<ProtectedRoute><Integrations /></ProtectedRoute>} />
              <Route path="/migration" element={<ProtectedRoute><Migration /></ProtectedRoute>} />
              <Route path="/team" element={
                <ProtectedRoute><AdminRoute><Team /></AdminRoute></ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute><SuperAdminRoute><Admin /></SuperAdminRoute></ProtectedRoute>
              } />
              <Route path="/admin/demo-requests" element={<ProtectedRoute><SuperAdminRoute><Admin /></SuperAdminRoute></ProtectedRoute>} />
              <Route path="/tasks" element={<ProtectedRoute><Tasks /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster
              theme="dark"
              position="bottom-right"
              toastOptions={{
                style: { background: "#1E293B", border: "1px solid #334155", color: "#F8FAFC" },
              }}
            />
          </BrowserRouter>
        </TooltipProvider>
      </WebSocketProvider>
    </AuthProvider>
  );
}
